import React, { useEffect, useMemo, useState } from "react";
import {
  formatDataVmailUnitelCompate,
  getDateChangeTime,
} from "../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../helper/const";
import FilterTime from "../../../components/FilterTime";
import { useSelector } from "react-redux";
import DashboardCompare from "../../components/DashboardCompare";
import { Tabs } from 'antd';
const { TabPane } = Tabs;

export default function Compare({ tabActive, handleGetData }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
    useSelector((state) => state.reducerVmUnitel?.data) || {};
  const { data: vm_unitel = [] } = result;

  useEffect(() => {
    if (tabActive !== "3") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const dataChart = useMemo(() => {
    const convertData = formatDataVmailUnitelCompate(
      vm_unitel,
      startDate,
      endDate
    );
    return convertData || [];
  }, [vm_unitel, startDate, endDate]);
  const dataChartMissCall = useMemo(() => {
    const convertData = formatDataVmailUnitelCompate(
      vm_unitel,
      startDate,
      endDate,
      true
    );
    return convertData || [];
  }, [vm_unitel, startDate, endDate]);
  const dataChartListenCall = useMemo(() => {
    const convertData = formatDataVmailUnitelCompate(
      vm_unitel,
      startDate,
      endDate,
      false,
      true
    );
    return convertData || [];
  }, [vm_unitel, startDate, endDate]);
  const dataChartQtyVM = useMemo(() => {
    const convertData = formatDataVmailUnitelCompate(
      vm_unitel,
      startDate,
      endDate,
      false,
      false,
      true
    );
    return convertData || [];
  }, [vm_unitel, startDate, endDate]);
  return (
    <>
          <div
            className="position-relative d-flex justify-right mb-2"
            style={{ justifyContent: "right" }}
          >
            <FilterTime
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </div>
     
      <Tabs defaultActiveKey="1">
        <TabPane tab="Fee" key="1">
          <div>
            <DashboardCompare
              dataChart={dataChart}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Miss call" key="2">
          <div>
            <DashboardCompare
              dataChart={dataChartMissCall}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Listen again" key="3">
          <div>
            <DashboardCompare
              dataChart={dataChartListenCall}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Quantity VM" key="4">
          <div>
            <DashboardCompare
              dataChart={dataChartQtyVM}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
}
